import { ReactNode } from "react";

type IconButtonContentProps = {
  children: ReactNode;
  icon: string;
};

export default function IconButtonContent({
  children,
  icon,
}: IconButtonContentProps) {
  return (
    <span className="button-content">
      <span
        className="button-content__icon material-symbols-outlined"
        aria-hidden="true"
      >
        {icon}
      </span>
      <span className="button-content__label">{children}</span>
    </span>
  );
}
